import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {PopupService} from '../../services/shared/popup.service';
import {ApplicationService} from '../../services/application.service';
import {CarrierService} from '../../services/carrier.service';
import {AuthWebService} from '../../services/authweb.service';
import {MonthlyComplianceService} from '../../services/monthly-compliance.service';
import {PlaceService} from '../../services/place.service';
import {UtilityServiceService} from '../../services/utility-service.service';
import {CountryService} from '../../services/country.service';
import {CarrierDriverService} from '../../carrier-driver/service/carrier-driver.service';
import {VehicleEntryService} from '../../services/vehicle-entry.service';
import {environment} from '../../../environments/environment';
import {ToastNotificationService} from '../../shared/toast-notification/toast-notification.service';
import {DocumentsServiceService} from '../../services/documents-service.service';
import {FreightTypeService} from '../../services/freight-type.service';
import {PermitService} from '../../services/permit.service';
import {DatePipe} from '@angular/common';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogService} from '../../services/shared/confirm-dialog/confirm-dialog.service';
import {data} from 'jquery';
import {connectableObservableDescriptor} from 'rxjs/internal/observable/ConnectableObservable';

@Component({
    selector: 'app-passenger-permits',
    templateUrl: './passenger-permits.component.html',
    styleUrls: ['./passenger-permits.component.scss']
})
export class PassengerPermitsComponent implements OnInit {
    carrierAccNumber: string = '';
    carrierType: string = '';
    carrierNames: string = '';
    processHeader: string;
    user: any = {};
    monthlyFowardsReturns: any = [];
    monthlyReturnsReturns: any = [];

    pageload: boolean = false;
    message = 'Loading page. Please wait...';

    selectedPlace: string;
    filteredNonSABorderCrossings: any[];
    docHeaders = 'Upload Passenger List'
    SAborderCrossings: any;
    SAPlaces: any;
    NonSABorderCrossings: any;
    AllPlaces: any;
    DestinationPlaces: any;
    Freighttypes: any = []
    countryList: any;
    carrierId: any;
    driverslist: any;
    vehicleRes: any[];
    permitId: any
    ComplianceReturnId: any;
    pdfSrc: any;
    isLoading: boolean = false;
    selectedreturnrow: any;
    img: null;
    filebytes: string;
    filename: any;
    filetype: any;
    filedescription: string;
    filesize: any;
    docTypeId: any = 67;
    appid: any;
    DocumentsToUpload: any = [];
    isPassenger: any = false;
    permitDetails: any;
    permitHeadingType = 'Passenger Permit';
    isLongShort = 'Long Term';
    permitExpiryDate: any;
    isFowards = true;
    closeResult: string = '';
    @ViewChild('add') addModal: NgbModal;
    noTripDesc: any;
    isNoTrip: any;
    remainingCharacters: any;
    complianceReturn: any;

    currentPage = 1;
    returnCurrentPage = 1;
    itemsPerPage = 7;
    allPermitReturns: any = [];

    registration_number: any;
    place_f1: any;
    place_f2: any;
    place_f3: any;
    place_f4: any;
    isAdmin: boolean = false;
    

    // Function to calculate the start index for the slice
    getStartIndex(): number {
        return (this.currentPage - 1) * this.itemsPerPage;
    }

    // Function to calculate the end index for the slice
    getEndIndex(): number {
        return this.getStartIndex() + this.itemsPerPage;
    }

    getReturnStartIndex(): number {
        return (this.returnCurrentPage - 1) * this.itemsPerPage;
    }

    getReturnEndIndex(): number {
        return this.getReturnStartIndex() + this.itemsPerPage;
    }

    // Function to calculate the total number of pages
    getTotalPages(): number {
        return Math.ceil(this.monthlyFowardsReturns.length / this.itemsPerPage);
    }

    getReturnTotalPages(): number {
        return Math.ceil(this.monthlyReturnsReturns.length / this.itemsPerPage);
    }

    // Function to generate an array of page numbers
    getPageNumbers(): number[] {
        const totalPages = this.getTotalPages();
        return Array.from({length: totalPages}, (_, i) => i + 1);
    }

    getReturnPageNumbers(): number[] {
        const totalPages = this.getReturnTotalPages();
        return Array.from({length: totalPages}, (_, i) => i + 1);
    }

    // Function to navigate to a specific page
    navigateToPage(page: number): void {
        if (page >= 1 && page <= this.getTotalPages()) {
            this.currentPage = page;
        }
    }

    returnNavigateToPage(page: number): void {
        if (page >= 1 && page <= this.getReturnTotalPages()) {
            this.returnCurrentPage = page;
        }
    }

    constructor(private router: Router, private modalService: NgbModal, private confirmDialogService: ConfirmDialogService, private authWebService: AuthWebService, private datePipe: DatePipe, private documentService: DocumentsServiceService, private permitService: PermitService, private toastService: ToastNotificationService, private activeRoute: ActivatedRoute, private showModal: PopupService, private vehicleEntryService: VehicleEntryService, private place: PlaceService, private freightService: FreightTypeService, private ultility: UtilityServiceService,
                public applicationService: ApplicationService, public carrierService: CarrierService, public monthlyComplianceService: MonthlyComplianceService, private country: CountryService, private driver: CarrierDriverService) {
    }


    addRow(item, i) {
        const copyItem = {...item};
        copyItem.id = 0;
        copyItem.document_total = 0;
        copyItem.freight_type_id = '';
        copyItem.num_pax = '';
        copyItem.mass_kg = '';


        if (item.forward_return_ind === 1) {
            let index = this.monthlyFowardsReturns.findIndex(x => x.reference === item.reference);
            this.monthlyFowardsReturns.splice(index + 1, 0, copyItem);
            this.monthlyFowardsReturns[index + 1].trip = true
            this.reloadReferences(index + 1, 1);
            if (i === 6) {
                this.navigateToPage(this.currentPage + 1)
            }
        } else {
            let index = this.monthlyReturnsReturns.findIndex(x => x.reference === item.reference);
            this.monthlyReturnsReturns.splice(index + 1, 0, copyItem);
            this.monthlyReturnsReturns[index + 1].trip = true
            this.reloadReferences(index + 1, 2);
            if (i === 6) {
                this.returnNavigateToPage(this.returnCurrentPage + 1)
            }

        }

    }

    setcurrentReturn(item) {
        this.selectedreturnrow = item;
        this.getComplianceTripDocuments(item.id);
    }

    saveReturn(item, i, type) {
        this.pageload = true;
        this.selectedreturnrow = item;
        console.log("Current Row", item);
        if (!item.registration_number || item.registration_number === 'undefined') {
            this.pageload = false;
            return this.toastService.error('Please ensure the vehicle registration details are selected before saving', 'Validation');
        }

        if (!item.place_id_f1 || !item.place_id_f2 || !item.place_id_f3 || !item.place_id_f4) {
            this.pageload = false;

            return this.toastService.error('Please ensure the places details selected before saving', 'Validation');
        }

        if (!item.driver_id) {
            this.pageload = false;
            return this.toastService.error('Please ensure the driver details selected before saving', 'Validation');
        }

        if (this.isPassenger && !item.num_pax) {
            this.pageload = false;
            return this.toastService.error('Please fill all the passenger number is specified before saving', 'Validation');
        }

        if (!this.isPassenger && (!item.mass_kg || !item.freight_type_id)) {
            this.pageload = false;
            return this.toastService.error('Please fill all the freight details are specified before saving', 'Validation');
        }
        this.monthlyComplianceService.savePermitReturnForwards(item).subscribe((result) => {
            this.pageload = false;
            if (type === 'forward') {
                let ix = this.monthlyFowardsReturns.findIndex(x => x.reference === item.reference);
                this.monthlyFowardsReturns[ix] = result;
                this.monthlyFowardsReturns[ix].trip = true;
            } else {
                let ix = this.monthlyReturnsReturns.findIndex(x => x.reference === item.reference);
                this.monthlyReturnsReturns[ix] = result;
                this.monthlyReturnsReturns[ix].trip = true;
            }
            this.pageload = false;
            this.toastService.success('Record saved Successfully', 'Monthly Compliance');
        }, (error) => {
            this.pageload = false;
            this.toastService.error('An error occurred: ' + error.message, 'Monthly Compliance');
        })
    }

    ngOnInit(): void {
        this.user = this.authWebService.userData
            ? this.authWebService.userData.User
            : null;

        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
            this.isAdmin = true;

        }
        this.activeRoute.params.subscribe((params: Params) => {
            this.carrierId = params['carrierid'];
            this.permitId = params['permitid'];
            this.ComplianceReturnId = params['compliancereturnid'];
            this.carrierService.getById(this.carrierId).subscribe((data: any) => {
                this.carrierNames = data.name;
                this.carrierAccNumber = data.carrier_code;
                this.carrierType = data.carrier_type_name;
                this.processHeader = 'Mothly Return -Passenger Permit';

            });
        });

        this.getAllPermitComplianceTrip(this.permitId)
        this.getMonthlyReturn();

    }

    getMonthReturnsForward() {
        this.pageload = true;
        var obj = {
            'PermitId': this.permitId,
            'ComplianceReturnId': this.ComplianceReturnId,
            'ForwardReturnInd': 1,
            'ForwardTripId': 0,
            'UserCreated': this.user.FirstName + ' ' + this.user.LastName,
            'UserUpdated': this.user.FirstName + ' ' + this.user.LastName,
        }

        this.monthlyComplianceService.loadReturnsData(obj).subscribe((data: any) => {
            this.monthlyFowardsReturns = data.forwardsTrips;
            this.monthlyReturnsReturns = data.returnTrips;
            this.registration_number = this.monthlyFowardsReturns[0]?.registration_number;
            let record = this.monthlyFowardsReturns.find(x => x.id === 0)
            this.place_f1 = record?.place_id_f1;
            this.place_f2 = record?.place_id_f2;
            this.place_f3 = record?.place_id_f3;
            this.place_f4 = record?.place_id_f4;

            console.log('Driver 1', this.registration_number)
            console.log('Place 1', this.place_f1)
            console.log('Place 2', this.place_f2)
            console.log('Place 3', this.place_f3)
            console.log('Place 4', this.place_f4)
            this.reloadReferences(0, 0, true)
            this.pageload = false;
            this.loadAllPlaces();
        });
    }

    clearDefault() {

    }

    reloadReferences(index = 0, type = 0, onload = false) {
        let i = 0
        let y = 0;

        this.monthlyFowardsReturns.forEach(mon => {
            i++
            if (this.complianceReturn?.status_ind !== 51 && !this.isAdmin) {
                mon.trip = mon.id !== 0;
            }
            mon.reference = i;
            if (onload && mon.id === 0) {
                mon.registration_number = '';
                mon.place_id_f1 = '';
                mon.place_id_f2 = '';
                mon.place_id_f3 = '';
                mon.place_id_f4 = '';
            }

            console.log("Forwards ", mon)
        });

        this.monthlyReturnsReturns.forEach(mon => {
            y++

            if (this.complianceReturn?.status_ind !== 51 && !this.isAdmin) {
                mon.trip = mon.id !== 0;
            }
            mon.reference = y;
            if (onload && mon.id === 0) {
                mon.registration_number = '';
                mon.place_id_f1 = '';
                mon.place_id_f2 = '';
                mon.place_id_f3 = '';
                mon.place_id_f4 = '';
            }

            console.log("Returns ", mon)

        });

        if (index !== 0 && type !== 0 && this.complianceReturn?.status_ind !== 51) {
            if (type === 1) {
                this.monthlyFowardsReturns[index].trip = true;
            } else if (type === 2) {
                this.monthlyReturnsReturns[index].trip = true;
            }
        }
    }

    getMonthReturnsReturn() {
        // this.pageload = true;
        var obj = {
            'PermitId': this.permitId,
            'ComplianceReturnId': this.ComplianceReturnId,
            'ForwardReturnInd': 2,
            'ForwardTripId': 0,
            'UserCreated': this.user.FirstName + ' ' + this.user.LastName,
            'UserUpdated': this.user.FirstName + ' ' + this.user.LastName,
        }

        this.monthlyComplianceService.loadReturnsData(obj).subscribe((data: any) => {
            this.monthlyReturnsReturns = data.returnTrips;
            this.monthlyReturnsReturns.forEach(mon => {
                mon.trip = mon.id !== 0;
            });
        });
    }

    setLastPlaceDestination() {
        if (this.AllPlaces.length > 0 && this.monthlyFowardsReturns.length > 0) {
            if (this.place_f4) {
                var lastborder = this.AllPlaces.find(x => x.id === this.place_f4);
                this.DestinationPlaces = this.AllPlaces.filter(x => x.country_id === lastborder.country_id && !x.is_border_post);
            } else {
                this.DestinationPlaces = this.AllPlaces.filter(x => !x.is_border_post);
            }
        } else {
            this.DestinationPlaces = this.AllPlaces.filter(x => !x.is_border_post);
        }
    }

    getPermitDetails() {
        this.permitService.getById(this.permitId).subscribe((data: any) => {
            this.permitDetails = data
            if (this.permitDetails.permit_type.freight_passenger_ind == 1) {
                this.isPassenger = false
                this.permitHeadingType = 'Freight Permit';
                this.docHeaders = 'Upload Manifest/Consignment Notes'
            } else {
                this.isPassenger = true
                this.permitHeadingType = 'Passenger Permit';
                this.docHeaders = 'Upload Passenger List'
            }

            if (this.permitDetails.permit_type.temp_long_ind == 1) {
                this.isLongShort = 'Short Term';
            } else {
                this.isLongShort = 'Long Term';
            }

            if (this.permitDetails.date_valid_to) {
                this.permitExpiryDate = this.datePipe.transform(this.permitDetails.date_valid_to, 'dd/MM/yyyy');
            }


        })
    }

    loadAllPlaces() {
        this.pageload = true;
        this.place.getPlaces().subscribe((data: any) => {
            this.AllPlaces = data;
            this.SAborderCrossings = data.filter(x => x.country_id === this.ultility.crossEasyCountries.sa && x.is_border_post)
            this.SAPlaces = data.filter(x => x.country_id === this.ultility.crossEasyCountries.sa && !x.is_border_post)
            this.NonSABorderCrossings = data.filter(x => x.is_border_post);
            this.setLastPlaceDestination();
            this.pageload = false;
        });
    }

    loadFreightTypes() {
        this.freightService.getAllFreightTypes().subscribe((data: any) => {
            this.Freighttypes = data;
        });
    }

    completeComplianceReturn() {
        console.log(this.complianceReturn);
        if (!this.complianceReturn) {
            return;
        }
        this.pageload = true;
        this.complianceReturn.status_ind = 51;
        this.complianceReturn.user_modified = this.user.FirstName + '' + this.user.LastName;
        this.monthlyComplianceService.updateComplianceReturn(this.complianceReturn).subscribe((data: any) => {
            if (data.isSuccess) {
                this.pageload = false;
                // this.router.navigate([
                //     '/monthly-compliance/list/' + this.carrierId
                // ]);
                this.toastService.success('Your monthly return have been saved successfully', 'Monthly Compliance');
                window.location.reload();
            } else {
                this.pageload = false;
                this.toastService.error('An error occurred - ' + data.message, 'Monthly Compliance');
            }
        }, (err) => {
            this.pageload = false;
            this.toastService.error('An error occurred - ' + err.message, 'Monthly Compliance');
        })

    }

    loadCarrierDrivers() {
        if (this.selectedreturnrow) {
            this.pageload = true;
        }
        this.driver.getCarrierDrivers(this.carrierId).subscribe((data: any) => {
            this.driverslist = data;
            if (this.selectedreturnrow) {
                this.pageload = false;
            }
        })
    }

    loadCarrierVehicles() {
        let object = {
            VehicleType: '',
            PermitType: '',
            VIN: '',
            Regnumber: '',
            Carriername: '',
            carriercode: '',
            CarrierId: this.carrierId,
            PageSize: 100,
            PageNumber: 1,
        };


        this.vehicleEntryService.searchVehicleV2(object).subscribe(
            (result: any) => {
                if (result == null) {
                    this.vehicleRes = [];
                    return;
                }

                this.vehicleRes = result.Items;
            },
            (error) => {
                // this.pageload = false;
            }
        );
    }

    pushFileIntoReturn(event) {
        let filesAmount = event.target.files.length;
        if (filesAmount > 1) {
            this.toastService.error(`Please select only one file at a time`, 'Upload File');
            return;
        }
        const reader = new FileReader();
        for (let findFile = 0; findFile < filesAmount; findFile++) {
            let allowedFileSize =
                environment.authWebApi.systemData.Configurations.find(
                    (p) => p.Code == 'MaxUploadMB1'
                );
            let maxAllowedSize = allowedFileSize.Value; //it is in MB
            let isFileAlreadyUploaded = false;
            let document_sizeMB = this.getFileSize(event.target.files[findFile]);

            if (maxAllowedSize <= document_sizeMB) {
                this.toastService.error(
                    'Please select image of less than 5 MB',
                    'Upload File'
                );
                return;
            }

            let typesOfFile = [];
            if (event.target.files[findFile].type !== '') {
                typesOfFile = this.getFileType(event.target.files[findFile]);
            }

            if (typesOfFile.length <= 0 || typesOfFile[1].toLowerCase() !== 'pdf') {
                this.toastService.error(
                    'Uploaded file is not a valid. PDF files are allowed',
                    'UploadFile'
                );
                return;
            }


            let file = event.target.files[0]
            reader.removeEventListener;
            reader.readAsDataURL(file);

            this.selectedreturnrow.document.forEach(
                (doc) => {
                    if (file.name == doc.file_name) {
                        this.toastService.error(
                            `You already uploaded this file`,
                            'File upload failed'
                        );
                        isFileAlreadyUploaded = true;
                        return;
                    }
                });

            if (!isFileAlreadyUploaded) {
                reader.onload = () => {
                    this.filebytes = reader.result.toString().split(',')[1];
                    (this.filename = file.name), (this.filetype = file.type);
                    this.filedescription = 'upload';
                    this.filesize = file.size;

                    const formdata = new FormData();
                    formdata.append('File', this.filebytes);
                    formdata.append('FileName', this.filename);
                    formdata.append('TypeOfFile', this.filetype);
                    formdata.append('description', this.filedescription);
                    formdata.append('FileSize', this.filesize);
                    formdata.append('VehicleName', 'VehicleName - ' + this.selectedreturnrow.registration);
                    formdata.append('ComplianceTripId', this.selectedreturnrow.id);
                    formdata.append('UserLastName', this.user.LastName);
                    formdata.append('documenttypeid', this.docTypeId);
                    formdata.append('PermitId', this.permitId);
                    formdata.append('shareId', this.appid);


                    var doc = {
                        'id': 0,
                        'code': '',
                        'description': '',
                        'document_type_id': 0,
                        'permit_id': 0,
                        'application_id': 0,
                        'carrier_id': 0,
                        'document_link': '',
                        'is_upload': false,
                        'is_permit': false,
                        'notes': '',
                        'file_name': this.filename,
                        'multiple_allowed': false,
                        'user_created': '',
                        'user_modified': '',
                        'vehicle_entry_id': null,
                        'compliance_detail_id': null,
                        'compliance_annual_id': null,
                        'is_compliance': null,
                        'carrier_ocas_id': null,
                        'group_code': ''
                    }

                    this.DocumentsToUpload.push(formdata);
                    if (!this.selectedreturnrow.document) {
                        this.selectedreturnrow.document = [];
                    }

                    this.selectedreturnrow.document.push(doc);


                }
            }
        }
    }

    gotoPassengerList(item) {
        //  :id/:carrierid/:permitid/:compliancereturnid
        this.router.navigate([
            '/monthly-compliance-passenger/list/' + item.id + '/' + this.carrierId + '/' + this.permitId + '/' + this.ComplianceReturnId,
        ]);
    }

    saveJustification() {
        this.pageload = true;
        var body = {
            id: this.ComplianceReturnId,
            nil_return_reason: this.noTripDesc,
            modified_by: this.user.FirstName + ' ' + this.user.LastName
        }
        this.monthlyComplianceService.declareNilReturns(body).subscribe((data: any) => {
            this.pageload = false;
            this.toastService.success('This month has been successfully declared for nil trips', 'Success');
            
            // Set a timeout to reload the window after a certain duration
            setTimeout(() => {
                window.location.reload();
            }, 4000); // Adjust the duration as needed
        }, (error) => {
            console.error('Error in declareNilReturns', error);
            this.pageload = false;
            this.toastService.error('An error occurred, please try again', 'Error');
        })
    }
    
    
    
    
    
    saveDocument() {

        if (this.DocumentsToUpload.length <= 0) {
            this.toastService.error(
                'No documents uploaded to save.',
                'Warning'
            );

            return;
        }

        for (let item of this.DocumentsToUpload) {


            this.pageload = true;

            this.documentService
                .PostMCScans(item)
                .subscribe(
                    (response) => {

                        console.log(response);
                        this.getComplianceTripDocuments(this.selectedreturnrow.id);
                        this.pageload = false;
                        this.toastService.success(
                            'File Uploads Successful.',
                            'File Uploads'
                        );
                    },
                    (error) => {
                        this.pageload = false;
                        this.toastService.error(
                            'File Upload Failed, Please try again.',
                            'Error'
                        );
                        // this.reload()
                    }
                );


        }

        this.DocumentsToUpload = [];
    }

    getMonthlyReturn() {
        this.pageload = true;
        this.monthlyComplianceService.getComplianceReturn(this.ComplianceReturnId).subscribe((data: any) => {
            this.complianceReturn = data;
            if (data.nil_return && !this.isAdmin) {
                this.noTripDesc = data.nil_return_reason;
                this.isNoTrip = data.nil_return;
                this.pageload = false;
                this.toastService.error('You have declared no trips for this month. If you wish to enter trips uncheck the no trips box', 'Warning');
            }
            if (data.nil_return && this.isAdmin) {
                this.noTripDesc = data.nil_return_reason;
                this.isNoTrip = data.nil_return;
                this.pageload = false;
                this.toastService.error('This month has been declared as nil trips', 'Error');
            }
            else {
                // this.loadNonSABordersCrossings();
                // this.loadSAPlaces();

                // this.loadSABordersCrossings();
                this.getMonthReturnsForward();
                // this.getMonthReturnsReturn();
                this.loadCarrierDrivers();
                this.loadFreightTypes();
                this.loadCarrierVehicles();
                this.getPermitDetails();
            }


        }, error => {
            this.pageload = false;
            this.toastService.error('An error occurred loading data, try refreshing the page to try again', 'Error');
        })
    }

    getFileType(file: File) {
        const typesOfFile = file.type.split('/');
        return typesOfFile;
    }

    getFileSize(file: File) {
        return file.size / 1000000;
    }

    viewDoc(doc) {
        const id = doc.document_link.toString().split('#')[1];
        this.isLoading = true;
        this.pdfSrc = null;
        this.img = null;
        let ext = doc.file_name.substring(doc.file_name.length - 3, doc.file_name.length);
        this.documentService.downloadpdf(id).subscribe((x: File) => {
            let objectURL = URL.createObjectURL(x);
            this.pdfSrc = objectURL;
            this.isLoading = false;
        });
    }

    removeUploadedFile(file) {

        this.confirmDialogService.confirmThis('Are you sure you want to delete the selected file. Press Yes to continue.', () => {

            this.pageload = true;
            this.documentService
                .DeletePaxDoc(file.id)
                .subscribe((deleteFile: any) => {
                    this.getComplianceTripDocuments(this.selectedreturnrow.id);
                    this.pageload = false;
                    this.toastService.success(
                        'Delete uploaded file successfully',
                        'Delete Document'
                    );
                }, error => {
                    this.pageload = false;
                    this.toastService.success(
                        'An error occurred while attmepting to delete document',
                        'Delete Document'
                    );
                });

        }, () => {
            return false;
        });


    }

    showForwardReturn(type: string) {
        if (type == 'Return') {
            this.isFowards = false;
        } else if (type == 'Forward') {
            this.isFowards = true;
        }
    }

    RegisterDriver() {
        this.modalService.open(this.addModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl', scrollable: true}).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
                this.loadCarrierDrivers();
            },
            (reason) => {
                this.closeResult = `Dismissed`;
                this.loadCarrierDrivers();
            },
        );
    }

    SetNoTrip() {
        if (this.isNoTrip) {

            this.confirmDialogService.confirmThis('You are about to declare that you did not have any trips for the selected month, this will delete the previously captured trips. Press Yes to continue.', () => {

                // Code to execute when the checkbox is checked
                document.getElementById('btnshowNoTrip').click();
                // You can call any other method or perform any logic here

            }, () => {
                this.isNoTrip = false;
                return false;
            });

        } else {
            // Code to execute when the checkbox is unchecked
            this.confirmDialogService.confirmThis(
                'You are about to undo the nil return for this month. Press Yes to continue.',
                () => {
                    if (!this.complianceReturn) {
                        return;
                    }
                    this.pageload = true;
                    this.complianceReturn.status_ind = 1;
                    this.complianceReturn.user_modified = this.user.FirstName + ' ' + this.user.LastName;
                    this.monthlyComplianceService.updateComplianceReturn(this.complianceReturn).subscribe(
                        (data: any) => {
                            if (data.isSuccess) {
                                this.pageload = false;
                                this.toastService.success('You can now enter your monthly return trips', 'Success');
            
                                // Set a timeout to reload the window after the toastr closes
                                setTimeout(() => {
                                    window.location.reload();
                                }, 15000); // Adjust the duration as needed
                            } else {
                                this.pageload = false;
                                // this.toastService.error('An error occurred - ' + data.message, 'Monthly Compliance');
                            }
                        }
                    );

            }, () => {
                this.isNoTrip = true;
                return false;
            });

            // You can call any other method or perform any logic here
        }
    }
    // Inside your component class
cancelModal() {
   
    this.isNoTrip = false;
}


    maxCharacters: number = 500;

    remainChar() {
        this.remainingCharacters = this.maxCharacters - this.noTripDesc.length;
        if (this.remainingCharacters <= 0) {
            this.noTripDesc = this.noTripDesc.slice(0, this.maxCharacters); // Trim the input to maxCharacters length
            this.remainingCharacters = 0; // Reset remainingCharacters to 0
        }
    }

    copyPrevious(item, event) {
        if (event.target.checked) {
            if (item.forward_return_ind === 1) {
                let ix = this.monthlyFowardsReturns.findIndex(x => x.reference === item.reference);
                if (ix > 0 && ix < this.monthlyFowardsReturns.length) {
                    let source = this.monthlyFowardsReturns[ix - 1];
                    if (source?.id === 0 || !source) {
                        this.toastService.error('You cant copy from the previous record return', 'Monthly Compliance');
                        this.monthlyFowardsReturns[ix].copyprevious = false;
                        return;
                    }
                    this.monthlyFowardsReturns[ix].registration_number = source.registration_number;
                    this.monthlyFowardsReturns[ix].driver_id = source.driver_id;
                    this.monthlyFowardsReturns[ix].place_id_f1 = source.place_id_f1;
                    this.monthlyFowardsReturns[ix].place_id_f2 = source.place_id_f2;
                    this.monthlyFowardsReturns[ix].place_id_f3 = source.place_id_f3;
                    this.monthlyFowardsReturns[ix].place_id_f4 = source.place_id_f4;
                    this.monthlyFowardsReturns[ix].freight_type_id = source.freight_type_id;
                    this.monthlyFowardsReturns[ix].mass_kg = source.mass_kg;
                    this.monthlyFowardsReturns[ix].num_pax = source.num_pax;
                }
            } else {
                let ix = this.monthlyReturnsReturns.findIndex(x => x.reference === item.reference);
                if (ix > 0 && ix < this.monthlyReturnsReturns.length) {
                    let source = this.monthlyReturnsReturns[ix - 1];
                    if (source?.id === 0 || !source) {
                        this.toastService.error('You cant copy from the previous record return', 'Monthly Compliance');
                        this.monthlyReturnsReturns[ix].copyprevious = false;
                        return;
                    }
                    this.monthlyReturnsReturns[ix].registration_number = source.registration_number;
                    this.monthlyReturnsReturns[ix].driver_id = source.driver_id;
                    this.monthlyReturnsReturns[ix].place_id_f1 = source.place_id_f1;
                    this.monthlyReturnsReturns[ix].place_id_f2 = source.place_id_f2;
                    this.monthlyReturnsReturns[ix].place_id_f3 = source.place_id_f3;
                    this.monthlyReturnsReturns[ix].place_id_f4 = source.place_id_f4;
                    this.monthlyReturnsReturns[ix].freight_type_id = source.freight_type_id;
                    this.monthlyReturnsReturns[ix].mass_kg = source.mass_kg;
                    this.monthlyReturnsReturns[ix].num_pax = source.num_pax;
                }
            }
        }
    }

    getComplianceTripDocuments(id) {
        this.pageload = true;
        this.documentService.getComplianceTrip(id).subscribe((data: any) => {
            if (this.selectedreturnrow.document) {
                this.selectedreturnrow.document = data;
                this.selectedreturnrow.document_total = data.length;
            } else {
                this.selectedreturnrow.document = [];
                this.selectedreturnrow.document = data;
                this.selectedreturnrow.document_total = data.length;
            }
            this.pageload = false;
        }, error => {
            this.toastService.error('An error occured while fetching data', 'Error');
            this.pageload = false;
            console.error('Documents', error);
        })
    }

    deleteComplianceTrip(item: any, event) {
        if (!event.target.checked && item !== 0) {
            this.pageload = false;
            this.monthlyComplianceService.deleteComplianceReturn(item.id).subscribe((data: any) => {
                if (item.forward_return_ind === 1) {
                    let ix = this.monthlyFowardsReturns.findIndex(x => x.reference === item.reference);
                    this.monthlyFowardsReturns[ix].id = 0;
                    this.monthlyFowardsReturns[ix].driver_id = '';
                    this.monthlyFowardsReturns[ix].freight_type_id = '';
                    this.monthlyFowardsReturns[ix].num_pax = '';
                    this.monthlyFowardsReturns[ix].mass_kg = '';
                    this.monthlyFowardsReturns[ix].registration_number = '';
                    this.monthlyFowardsReturns[ix].place_id_f1 = '';
                    this.monthlyFowardsReturns[ix].place_id_f2 = '';
                    this.monthlyFowardsReturns[ix].place_id_f3 = '';
                    this.monthlyFowardsReturns[ix].place_id_f4 = '';
                    this.monthlyFowardsReturns[ix].document_total = 0;

                }
                if (item.forward_return_ind === 2) {
                    let ix = this.monthlyReturnsReturns.findIndex(x => x.reference === item.reference);
                    this.monthlyReturnsReturns[ix].id = 0;
                    this.monthlyReturnsReturns[ix].driver_id = '';
                    this.monthlyReturnsReturns[ix].freight_type_id = '';
                    this.monthlyReturnsReturns[ix].num_pax = '';
                    this.monthlyReturnsReturns[ix].mass_kg = '';
                    this.monthlyReturnsReturns[ix].registration_number = '';
                    this.monthlyReturnsReturns[ix].place_id_f1 = '';
                    this.monthlyReturnsReturns[ix].place_id_f2 = '';
                    this.monthlyReturnsReturns[ix].place_id_f3 = '';
                    this.monthlyReturnsReturns[ix].place_id_f4 = '';
                    this.monthlyReturnsReturns[ix].document_total = 0;

                }
                this.pageload = false;
            })
        } else if (event.target.checked) {
            if (item.forward_return_ind === 1) {
                item.registration_number = this.registration_number;
                item.place_id_f1 = this.place_f1;
                item.place_id_f2 = this.place_f2;
                item.place_id_f3 = this.place_f3;
                item.place_id_f4 = this.place_f4;
            } else if (item.forward_return_ind === 2) {
                item.registration_number = this.registration_number;
                item.place_id_f1 = this.place_f4;
                item.place_id_f2 = this.place_f3;
                item.place_id_f3 = this.place_f2;
                item.place_id_f4 = this.place_f1;
            }
        }
    }

    getAllPermitComplianceTrip(permitId) {
        this.monthlyComplianceService.getAllPermitReturn(permitId).subscribe((data: any) => {
            console.log('Compliance Documents', data);
            this.allPermitReturns = data;
        });
    }

    changePermits() {
        this.getMonthlyReturn();
    }
}
